import React from "react";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { capitalizeFirstLetter } from "../../../../../helpers/functions";
import {
  AMRReferralTypeOptions,
  designationOptions,
  referralTypeCard,
} from "./data";
import { ClinicalServiceTypes } from "../../../text/data";
import { Menu, Transition } from "@headlessui/react";
import { ReactSVG } from "react-svg";
import { Fragment } from "react";
import { stateOptions } from "../../../create/options";

const ReferralCard = ({
  clinicalServiceName,
  referral,
  onEdit = () => {},
  onDelete = () => {},
}) => {
  return (
    <>
    <div className="relative h-[595px] border min-w-[480px] border-gray-100 rounded bg-gray-10">
      <div className="flex w-full items-center justify-between px-6 py-3 bg-gray-20 border-b border-gray-100">
        <h4 className="text-lg font-bold text-teal-600">
          Referral Information
        </h4>
        <Menu as="div" className="relative">
          <div className="">
            <Menu.Button>
              <ReactSVG
                src={`/icons/triple-dot.svg`}
                className={`flex !items-center py-2 px-3 rounded-md hover:bg-gray-300 transform scale-125`}
              />
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform translate-y-2 opacity-0 scale-95"
            enterTo="transform translate-y-0 opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform translate-y-0 opacity-100 scale-100"
            leaveTo="transform translate-y-2 opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-8 top-0 w-24 origin-top-right bg-white divide-y divide-gray-20 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-[1000]">
              <Menu.Item>
                <button
                  className="block w-full text-left px-3 py-3 border-b border-b-gray-20 hover:bg-gray-100"
                  onClick={() => onEdit()}
                >
                  Edit
                </button>
              </Menu.Item>
              <Menu.Item>
                <button
                  className="block w-full text-left px-3 py-3 border-b border-b-gray-20 hover:bg-gray-100"
                  onClick={() => onDelete()}
                >
                  Delete
                </button>
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
        {/* <div className="flex">
          <button
            className="p-1.5 mr-3 rounded-lg action-item"
            onClick={() => onDelete()}
          >
            <TrashIcon className="w-5 h-5 text-red-300" />
          </button>
          <button
            className="p-1.5 rounded-lg action-item"
            onClick={() => onEdit()}
          >
            <PencilIcon className="w-4 h-5 text-teal-600" />
          </button>
        </div> */}
      </div>
      <div className="h-[520px] overflow-auto overflow-y-auto">
      <div className="px-6 py-3.5 w-full">
        <div className="grid grid-cols-1">
          <div>
            <p className="mb-1.5 text-sm text-gray-700">Referral Type</p>
            <p className="text-body-md font-bold text-gray-800">
              {clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis
                ? capitalizeFirstLetter(
                    referralTypeCard.options.filter(
                      (x) => x.value === referral?.referralType
                    )[0]?.label
                  )
                : capitalizeFirstLetter(
                    AMRReferralTypeOptions.filter(
                      (x) => x.value === referral?.referralType
                    )[0]?.label
                  )}
            </p>
          </div>
          <div className="col-span-3 border-b border-b-gray-100 mb-3 pt-2.5"></div>
          {referral.clinicName && (
            <>
              <div>
                <p className="mb-1.5 text-sm text-gray-700">
                  {referral?.referralType === "Emergency - No Primary Provider"
                    ? "Hospital - ER Dept Name"
                    : "Walk In Clinic Name"}
                </p>
                <p className="text-body-md font-bold text-gray-800">
                  {capitalizeFirstLetter(referral?.clinicName)}
                </p>
              </div>
              <div className="col-span-3 border-b border-b-gray-100 mb-3 pt-2.5"></div>
            </>
          )}
          <div>
            <p className="mb-1.5 text-sm text-gray-700">Name</p>
            <p className="text-body-md font-bold text-gray-800">
              {capitalizeFirstLetter(referral?.firstName)}{" "}
              {capitalizeFirstLetter(referral?.lastName)}
            </p>
          </div>
          <div className="col-span-3 border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="grid grid-cols-2">
            <div>
              <p className="mb-1.5 text-sm text-gray-700">Designation</p>
              <p className="text-body-md font-bold text-gray-800">
                {capitalizeFirstLetter(
                  designationOptions.filter(
                    (x) => x.value === referral?.designation
                  )[0]?.label
                )}
              </p>
            </div>
            <div>
              <p className="mb-1.5 text-sm text-gray-700">License Number</p>
              <p className="text-body-md font-bold text-gray-800">
                {referral?.licenseNumber}
              </p>
            </div>
          </div>
          <div className="col-span-3 border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div>
            <p className="mb-1.5 text-sm text-gray-700">Email</p>
            <p className="text-body-md font-bold text-gray-800">
              {referral?.emailAddress}
            </p>
          </div>
          <div className="col-span-3 border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="grid grid-cols-2">
            <div>
              <p className="mb-1.5 text-sm text-gray-700">Phone</p>
              <p className="text-body-md font-bold text-gray-800">
                {referral?.phoneNumber}
              </p>
            </div>
            <div>
              <p className="mb-1.5 text-sm text-gray-700">Fax</p>
              <p className="text-body-md font-bold text-gray-800">
                {referral?.fax}
              </p>
            </div>
          </div>
          <div className="col-span-3 border-b border-b-gray-100 mb-3 pt-2.5"></div>
          {/* <div>
            <p className="mb-1.5 text-sm text-gray-700">Address</p>
            <p className="text-body-md font-bold text-black">
              {referral?.address} <br />
              {referral?.city && referral?.city + ", "} {referral?.province}
              <br />
              {referral?.postalCode}
              <br />
              {referral?.country}
            </p>
          </div> */}
          <div>
            <p className="mb-1.5 text-sm text-gray-700">Address</p>
            <p className="text-body-md font-bold text-gray-800">
              {referral?.address ? `${referral?.address}, ` : ""}
              {referral?.poBox && `PO Box: ${referral?.poBox}, `}
              {referral?.unitNumber && `Unit # ${referral?.unitNumber} `}
            </p>
          </div>
          <div className="col-span-3 border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="grid grid-cols-2">
            <div>
              <p className="mb-1.5 text-sm text-gray-700">City/Town</p>
              <p className="text-body-md font-bold text-gray-800">
                {referral?.city}
              </p>
            </div>
            <div>
              <p className="mb-1.5 text-sm text-gray-700">Province</p>
              <p className="text-body-md font-bold text-gray-800">
                {
                  stateOptions.find(
                    (option) => option.value === referral?.province
                  )?.label
                  // --Cannot read properties of undefined (reading 'label')------------
                }
              </p>
            </div>
          </div>
          <div className="col-span-3 border-b border-b-gray-100 mb-3 pt-2.5"></div>
          <div className="grid grid-cols-2">
            <div>
              <p className="mb-1.5 text-sm text-gray-700">Postal Code</p>
              <p className="text-body-md font-bold text-gray-800">
                {referral?.postalCode}
              </p>
            </div>
            <div>
              <p className="mb-1.5 text-sm text-gray-700">Country</p>
              <p className="text-body-md font-bold text-gray-800">
                {referral?.country}
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    </>
  );
};

export default ReferralCard;
